import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { QRCodeSVG } from "qrcode.react";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import testProductBg from "resources/test/testProductBg.png";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { toast } from "react-toastify";

function ModalTestPage() {
    const { isMobile } = useContext(BrowserDetectContext);
    const [isMounted, setMounted] = useState(false);
    const [paymentResult, setPaymentResult] = useState();
    const id = 5;
    const dispatch = useDispatch();
    const testOrderData = {
        "orderProducts": [
            {
                "id": "a5b06212-89d5-4065-b8d5-a9c8fed9183c",
                "vendorId": null,
                "categoryId": "6873ea91-b0ac-4fad-afee-fa3f13f41849",
                "brandId": null,
                "storeId": null,
                "productId": null,
                "machineId": null,
                "machineType": null,
                "vendorName": null,
                "productName": "아모스 딱풀",
                "locationNo": 0,
                "price": 1000,
                "supplyPrice": 700,
                "productImg": "http://worldintrest1.cafe24.com/fileServer/files/product/7b0fa734-0ab1-4313-96a4-0b3e6400222a.png",
                "vendingId": null,
                "quantity": 1,
                "radarImg": "http://worldintrest1.cafe24.com/fileServer/files/product/ec8ff610-f12c-43b6-b87b-001e9755139f.png",
                "bannerTextImg": "http://worldintrest1.cafe24.com/fileServer/files/product/55d5d4b0-8ad8-4dfa-a97d-6185caa438a0.png",
                "liquidImg": "http://worldintrest1.cafe24.com/fileServer/files/product/5a849551-0c3c-4ebb-a6ea-dac089346017.png",
                "productDetailImg": "PHA+JiN4YzU0NDsmI3hiYWE4OyYjeGMyYTQ7ICYjeGI1MzE7JiN4ZDQ4MDsgPC9wPg==",
                "productBgImg": "http://worldintrest1.cafe24.com/fileServer/files/product/b39a5c4a-d60b-4a1e-8a66-d59c2040c72a.png"
            }
        ],
        "amount": 1000,
        "userName": "admin",
        "storeCode": "5",
        "machineData": "W1swLDFdXQ==",
        "returnUrl": "http://118.42.47.43:3000/ws/5/homepage"
    }

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            TestOnClick();
        }
    }, [isMounted])


    const PaymentQR = () => {


        const trxId = paymentResult && paymentResult.link.trxId;
        const trackId = paymentResult && paymentResult.link.trackId;
        const amount = paymentResult && paymentResult.link.amount;
        const storeCode = paymentResult && paymentResult.link.udf1;
        const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";

        const param = `data=W1swLDFdXQ==`;

        return (
            <QRCodeSVG
                value={`5/payment?${param}&trxId=${trxId}&trackId=${trackId}&amount=${amount}&storeCode=${storeCode}&deviceCode=${deviceCode}`}
                size={"20vw"}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={false}
            />
        );
    }

    const TestOnClick = () => {
        const jsonString = JSON.stringify(testOrderData);
        
        requester.testPaymentRequest(testOrderData, (result) => {
            if (result.code === 0) {
                const jsonString = JSON.stringify(result.data);
                
                
                let ready = result.data;
                requester.testPayment(ready, (result) => {
                    
                    
                    if (result.code === 0) {
                        // navigate("/payment", { state: { data: result.data } })
                        setPaymentResult(result.data);
                        
                        
                        const jsonString = JSON.stringify(result.data);
                        
                        if (window.BRIDGE && window.BRIDGE.sendPaymentResult) {
                            window.BRIDGE.sendPaymentResult(jsonString);
                        }
                        
                    }
                })
            } else {
                toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        })


    }


    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={30}>
                    <FlexChild>
                        <PaymentQR />
                    </FlexChild>
                    <FlexChild>
                        <CustomButton text={"REFRESH"} onClick={() => TestOnClick()} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default ModalTestPage;